import mailIcon from "../../../../assets/mail-icon.svg";
import phoneIcon from "../../../../assets/phone-icon.svg";
import countryIcon from "../../../../assets/country-icon.svg";

import telegramIcon from "../../../../assets/telegram-icon.svg";
import linkedinIcon from "../../../../assets/linkedin-icon.svg";
import xIcon from "../../../../assets/x-icon.svg";
import facebookIcon from "../../../../assets/facebook-icon.svg";
import youtubeIcon from "../../../../assets/youtube-icon.svg";

export default function ProfileGeneralTab({ details }) {
  return (
    <>
      <div className="profile-tab-all">
        <div className="profile-description profile-single-all">
          <span>Description</span>

          {details.profile.bio ? (
            <p>{details.profile.bio}</p>
          ) : (
            <p>No description</p>
          )}
        </div>
        <div className="separator"></div>
        <div className="profile-contact-info profile-single-all">
          <div className="profile-contact-info__single">
            <div className="profile-contact-info__single--icon">
              <img src={mailIcon} alt="mail" />
            </div>
            <div className="profile-content-info__single--text">
              <span>Contact Email</span>
              <p>{details.email}</p>
            </div>
          </div>
          <div className="profile-contact-info__single">
            <div className="profile-contact-info__single--icon">
              <img src={phoneIcon} alt="mail" />
            </div>
            <div className="profile-content-info__single--text">
              <span>Contact Phone</span>
              <p>{details.profile.phone}</p>
            </div>
          </div>
          {details.profile.country && (
            <div className="profile-contact-info__single">
              <div className="profile-contact-info__single--icon">
                <img src={countryIcon} alt="mail" />
              </div>
              <div className="profile-content-info__single--text">
                <span>Country</span>
                <p>{details.profile.country}</p>
              </div>
            </div>
          )}
        </div>
        <div className="separator"></div>
        <div className="profile-social-media profile-single-all">
          <span>Social Media</span>
          <div className="profile-social-media__wrapper">
            {details.profile.linkedin && (
              <a href={details.profile.linkedin}>
                <img src={linkedinIcon} alt="linkedin" />
              </a>
            )}
            {details.profile.telegram && (
              <a href={details.profile.telegram}>
                <img src={telegramIcon} alt="telegram" />
              </a>
            )}
            {details.profile.twitter && (
              <a href={details.profile.twitter}>
                <img src={xIcon} alt="x" />
              </a>
            )}
            {details.profile.facebook && (
              <a href={details.profile.facebook}>
                <img src={facebookIcon} alt="facebook" />
              </a>
            )}
            {details.profile.youtube && (
              <a href={details.profile.youtube}>
                <img src={youtubeIcon} alt="youtube" />
              </a>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
